var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftLeaf = function SvgLeftLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71A20F",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M2.859 14.533c-2.8-.457-1.206 6.435.872 9.98.17.291.486.458.823.458h28.332c.148 0 .295-.036.434-.091 1.676-.663 3.137.214 3.282-7.85.139-7.715-2.818-7.218-4.677-5.756-.298.234-.425.478-.54.117-.61-1.94-3.398-9.664-7.344-9.569-4.822.116-5.503 7.002-5.378 7.77S14.613-1.144 9.12 1.268C3.63 3.681 6.448 13.99 8.544 18.843c-.676-1.238-2.76-3.833-5.685-4.31Z"
  })));
};
export default SvgLeftLeaf;